<app-error-page [errorMsg]="errorMsg" *ngIf="containsError"></app-error-page>

<div *ngIf="!containsError">
  <div class="pageHeader">List of Loans</div>
  <div class="u-scroll-x">
    <div class="download-button">

      <div class="select-style">
        <fm-select
          [options]="pageView"
          placeholder="Choose"
          [(ngModel)]="selectedPageView"></fm-select>
      </div>
      <button fmButton class="ok-button" type="button" [small]="true" label="Ok" (click)='pageViewAction(dt)'></button>
     </div>
     <br><br>
    <fm-table #dt [columns]="cols" [value]="showResult" [paginator]="true" [rows]="10" [compressed]="true"
      [autoLayout]="true" [rowsPerPageOptions]="[10,25,50]" [enableTableEntryTotal]="true">
      <ng-template fmTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" class="row-selection">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template fmTemplate="body" let-rowData let-columns="columns">
        <tr>
          <td class="td-content" *ngFor="let col of columns">
            <span *ngIf="col.header==='Loan Number'">
              <a (click)="showLoanDetails(rowData)" class="detail-link">{{rowData[col.field]}} </a>
            </span>
            <span *ngIf="col.header!=='Loan Number'"> {{rowData[col.field]}}</span>

          </td>
        </tr>
      </ng-template>
    </fm-table>
  </div>
  <span></span>

  <div class="u-mb-150">
    <button fmButton type="button" [primary]="true" label="Cancel" [small]="true" routerLink="/queryLoans"
      class="buttonmargin"></button>

  </div>

</div>